import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import * as customerActions from "../../../actions/customerActions";
import * as contactActions from "../../../actions/contactActions";
import * as modalActions from "../../../actions/modalActions";
import * as codeActions from "../../../actions/codeActions";

import CustomerLocationList from "./CustomerLocationList";
import CustomerLocationForm from "./CustomerLocationForm";
import Modal from "../../common/Modal";
import HeaderWrapper from "../../common/HeaderWrapper";
import ConfirmModal from "../../common/ConfirmModal";

class CustomerLocationsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { search: "", location: {} };
  }

  componentDidMount = () => {
    const { match, actions } = this.props;

    actions.getCustomer(match.params.id);
  };

  onClickAdd = () => {
    this.setState({ location: {}, adding: true });
    this.props.actions.showModalSuccess("customerDetailsModal");
  };

  onClickView = (locationId) => {
    const { customer } = this.props;
    const location = customer.locations.find((loc) => loc._id === locationId);
    this.setState({ location, adding: false });
    this.props.actions.showModalSuccess("customerDetailsModal");
  };

  onClickDelete = (locationId) => {
    this.props.actions.requestLocationId(locationId);
  };

  handleAdd = (location) => {
    const { customer } = this.props;
    this.props.actions.createLocation(customer._id, location);
  };

  handleSave = (location) => {
    const { customer } = this.props;
    this.props.actions.updateLocation(customer._id, location);
  };

  handleDelete = () => {
    const { customer, customerLocationToDelete } = this.props;
    this.props.actions.deleteLocation(customer._id, customerLocationToDelete);
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { customer, codes, isMobile } = this.props;
    const { location, search, adding } = this.state;

    const locationForm = (
      <CustomerLocationForm
        location={location}
        codes={codes}
        editing
        adding={adding}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        savingCustomer={this.props.savingCustomer}
      />
    );

    return (
      <div id="locations">
        <HeaderWrapper
          breadcrumbs={[{ label: "Locations" }]}
          onClickEdit={this.handleEdit}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <CustomerLocationList
            minimal
            customer={customer}
            codes={codes}
            search={search}
            isMobile={isMobile}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
          />
        </div>
        <Modal
          id="customerDetailsModal"
          title={this.state.location.name || "Add Customer Location"}
          body={locationForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="locationDeleteModal"
          title="Delete Location"
          body="Are you sure you want to delete this location?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </div>
    );
  }
}

CustomerLocationsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  customer: PropTypes.object,
  codes: PropTypes.array,
  isMobile: PropTypes.bool,
  match: PropTypes.object,
  params: PropTypes.object,
  customerLocationToDelete: PropTypes.string,
  savingCustomer: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    codes: state.reducers.codes,
    customer: state.reducers.customer,
    customerLocationToDelete: state.reducers.customerLocationToDelete,
    savingCustomer: state.reducers.savingCustomer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions,
        ...contactActions,
        ...modalActions,
        ...codeActions
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(CustomerLocationsPage)
);
